export const IMAGES = {
  heroChauffeur: "https://images.unsplash.com/photo-1558222209-134191edfe0d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBjaGF1ZmZldXIlMjBvcGVuaW5nJTIwY2FyJTIwZG9vcnxlbnwwfHx8fDE3ODU1OTQxNTd8MA&ixlib=rb-4.1.0&q=85",
  sedan: "https://images.unsplash.com/photo-1485291571150-772bcfc10da5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxibGFjayUyMGx1eHVyeSUyMHNlZGFuJTIwbmlnaHR8ZW58MHx8fHwxNzg1NTk0MTU3fDA&ixlib=rb-4.1.0&q=85",
  suv: "https://images.unsplash.com/photo-1735620731955-b047a7122892?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxibGFjayUyMGx1eHVyeSUyMHN1diUyMHByb2ZpbGV8ZW58MHx8fHwxNzg1NTk0MTU3fDA&ixlib=rb-4.1.0&q=85",
  interior: "https://images.unsplash.com/photo-1605437241278-c1806d14a4d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBibGFjayUyMGNhciUyMGludGVyaW9yJTIwbGVhdGhlcnxlbnwwfHx8fDE3ODU1OTQzMDh8MA&ixlib=rb-4.1.0&q=85",
  night: "https://images.unsplash.com/photo-1513061379709-ef0cd1695189?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxjaXR5JTIwbmlnaHQlMjBza3lsaW5lJTIwbHV4dXJ5JTIwdHJhdmVsfGVufDB8fHx8MTc4NTU5NDMwOHww&ixlib=rb-4.1.0&q=85",
  wedding: "https://images.unsplash.com/photo-1592514313074-794923c98162?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwd2VkZGluZyUyMGx1eHVyeSUyMGNhcnxlbnwwfHx8fDE3ODU1OTQzMDh8MA&ixlib=rb-4.1.0&q=85",
  airport: "https://images.unsplash.com/photo-1549897411-b06572cdf806?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxhaXJwb3J0JTIwcHJpdmF0ZSUyMHRlcm1pbmFsJTIwbHV4dXJ5fGVufDB8fHx8MTc4NTU5NDMwOHww&ixlib=rb-4.1.0&q=85",
  texture: "https://images.unsplash.com/photo-1594896733292-9a77b5809c63?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGRhcmslMjBnb2xkJTIwdGV4dHVyZXxlbnwwfHx8fDE3ODU1OTQxNTd8MA&ixlib=rb-4.1.0&q=85",
  mercedes: "/fleet/mercedes.jpg",
  suburban: "/fleet/suburban.jpg",
  yukon: "/fleet/yukon.jpg",
  cadillac: "/fleet/cadillac.jpg",
  cadillac_int1: "/fleet/cadillac_int1.jpg",
  cadillac_int2: "/fleet/cadillac_int2.jpg",
  cadillac_int3: "/fleet/cadillac_int3.jpg",
  mercedes_int1: "/fleet/mercedes_int1.jpg",
  mercedes_int2: "/fleet/mercedes_int2.jpg",
  mercedes_int3: "/fleet/mercedes_int3.jpg",
  suburban_int1: "/fleet/suburban_int1.jpg",
  suburban_int2: "/fleet/suburban_int2.jpg",
  suburban_int3: "/fleet/suburban_int3.jpg",
  yukon_int1: "/fleet/yukon_int1.jpg",
  yukon_int2: "/fleet/yukon_int2.jpg",
  yukon_int3: "/fleet/yukon_int3.jpg",
  interior2: "https://images.unsplash.com/photo-1760688965950-e8dcca426544?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  interior3: "https://images.pexels.com/photos/17791133/pexels-photo-17791133.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  steering: "https://images.unsplash.com/photo-1590363718527-ee10f1861bf6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

// Shown until enough real 5-star client reviews come in via the rating system.
export const DEFAULT_REVIEWS = [
  { name: "Daniel", rating: 5, comment: "Flawless from the airport to downtown. The chauffeur tracked my delayed flight and was waiting with water and a warm car. This is how travel should feel.", service: "Airport Transfer" },
  { name: "Priya", rating: 5, comment: "Booked an SUV for our wedding day and everything was immaculate — early, elegant, and completely stress-free. Worth every dollar.", service: "Weddings" },
  { name: "Marcus", rating: 5, comment: "I use Namarck for all my client pickups now. Always on time, discreet, and the cars are spotless. My go-to in the GTA.", service: "Corporate" },
  { name: "Aisha", rating: 5, comment: "The evening ride to a gala was pure luxury — smooth, quiet, and the driver knew every shortcut. Five stars isn't enough.", service: "Events" },
];


export const SERVICES = [
  {
    num: "01",
    title: "Airport Transfers",
    desc: "Punctual, flight-tracked arrivals and departures. Meet-and-greet, luggage assistance, and a seamless door-to-terminal experience.",
    image: IMAGES.airport,
  },
  {
    num: "02",
    title: "Weddings",
    desc: "Arrive as the moment deserves. Immaculate vehicles, ribboned detailing, and a chauffeur who choreographs every second of the day.",
    image: IMAGES.wedding,
  },
  {
    num: "03",
    title: "Corporate",
    desc: "Discreet, reliable executive travel. Roadshows, client hosting, and hourly-as-directed service billed with total transparency.",
    image: IMAGES.interior,
  },
  {
    num: "04",
    title: "Night Out",
    desc: "The city after dark, on your terms. Point-to-point elegance for dinners, galas, and evenings that shouldn't end in a queue.",
    image: IMAGES.night,
  },
];

export const FLEET = [
  {
    id: "cadillac-xts",
    name: "Cadillac XTS",
    tagline: "The Livery Standard",
    class: "Sedan",
    priceFrom: 55,
    seats: 3,
    bags: 3,
    image: IMAGES.cadillac,
    features: ["Full-grain leather", "Rear climate control", "Privacy glass", "Complimentary water", "Wi-Fi onboard"],
    gallery: [IMAGES.cadillac, IMAGES.cadillac_int1, IMAGES.cadillac_int2, IMAGES.cadillac_int3],
  },
  {
    id: "mercedes-s-class",
    name: "Mercedes S-Class",
    tagline: "First Class on Wheels",
    class: "Sedan",
    priceFrom: 65,
    seats: 3,
    bags: 3,
    image: IMAGES.mercedes,
    features: ["Nappa leather", "Executive rear seating", "Ambient lighting", "Massage seats", "Wi-Fi onboard"],
    gallery: [IMAGES.mercedes, IMAGES.mercedes_int1, IMAGES.mercedes_int2, IMAGES.mercedes_int3],
  },
  {
    id: "chevrolet-suburban",
    name: "Chevrolet Suburban",
    tagline: "Room for Everyone",
    class: "SUV",
    priceFrom: 75,
    seats: 7,
    bags: 6,
    image: IMAGES.suburban,
    features: ["Seats up to 7", "Extended luggage", "Tri-zone climate", "Privacy glass", "Wi-Fi onboard"],
    gallery: [IMAGES.suburban, IMAGES.suburban_int1, IMAGES.suburban_int2, IMAGES.suburban_int3],
  },
  {
    id: "gmc-yukon-elevation",
    name: "GMC Yukon Elevation",
    tagline: "Presence & Space",
    class: "SUV",
    priceFrom: 78,
    seats: 6,
    bags: 5,
    image: IMAGES.yukon,
    features: ["2026 GMC Yukon Elevation", "Captain's seating", "Panoramic roof", "Climate zones", "Extended luggage"],
    gallery: [IMAGES.yukon, IMAGES.yukon_int1, IMAGES.yukon_int2, IMAGES.yukon_int3],
  },
];

export const SERVICE_OPTIONS = ["Airport Transfer", "Wedding", "Corporate", "Night Out", "Other"];
export const VEHICLE_OPTIONS = ["Cadillac XTS", "Mercedes S-Class", "Chevrolet Suburban", "GMC Yukon Elevation"];

// Lightweight Toronto/GTA location index (name -> coords) for autocomplete + fare estimate
export const TORONTO_LOCATIONS = [
  { name: "Pearson Intl Airport (YYZ)", lat: 43.6777, lng: -79.6248 },
  { name: "Billy Bishop Airport (YTZ)", lat: 43.6285, lng: -79.396 },
  { name: "Union Station, Downtown", lat: 43.6453, lng: -79.3806 },
  { name: "CN Tower", lat: 43.6426, lng: -79.3871 },
  { name: "Yorkville", lat: 43.6712, lng: -79.3912 },
  { name: "Distillery District", lat: 43.6503, lng: -79.3599 },
  { name: "Liberty Village", lat: 43.6371, lng: -79.42 },
  { name: "Rosedale", lat: 43.6796, lng: -79.3776 },
  { name: "The Beaches", lat: 43.671, lng: -79.293 },
  { name: "High Park", lat: 43.6465, lng: -79.4637 },
  { name: "North York", lat: 43.7615, lng: -79.4111 },
  { name: "Scarborough", lat: 43.7764, lng: -79.2318 },
  { name: "Etobicoke", lat: 43.6205, lng: -79.5132 },
  { name: "Mississauga", lat: 43.589, lng: -79.6441 },
  { name: "Vaughan", lat: 43.8361, lng: -79.4985 },
  { name: "Markham", lat: 43.8561, lng: -79.337 },
  { name: "Richmond Hill", lat: 43.8828, lng: -79.4403 },
  { name: "Brampton", lat: 43.7315, lng: -79.7624 },
  { name: "Oakville", lat: 43.4675, lng: -79.6877 },
  { name: "Niagara Falls", lat: 43.0896, lng: -79.0849 },
];

// Fare model (Toronto defaults): base + per-km, minimum = base.
export const FARE_RATES = {
  "Cadillac XTS": { base: 55, perKm: 1.75 },
  "Mercedes S-Class": { base: 65, perKm: 1.95 },
  "Chevrolet Suburban": { base: 75, perKm: 2.30 },
  "GMC Yukon Elevation": { base: 78, perKm: 2.40 },
};
export const HOURLY_RATES = {
  "Cadillac XTS": 82,
  "Mercedes S-Class": 95,
  "Chevrolet Suburban": 108,
  "GMC Yukon Elevation": 112,
};
export const MIN_HOURS = 2;
export const DEPOSIT_PCT = 0.25;
export const HST_RATE = 0.13;

function haversineKm(a, b) {
  const R = 6371;
  const dLat = ((b.lat - a.lat) * Math.PI) / 180;
  const dLng = ((b.lng - a.lng) * Math.PI) / 180;
  const s =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((a.lat * Math.PI) / 180) * Math.cos((b.lat * Math.PI) / 180) * Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s));
}

// Real driving distance (km) between {lat,lng} points via OSRM; haversine*1.3 fallback.
export async function routeKm(p, d) {
  const info = await routeInfo(p, d);
  return info.km;
}

// Real driving distance (km) + duration (minutes) via OSRM; haversine fallback.
export async function routeInfo(p, d) {
  try {
    const r = await fetch(`https://router.project-osrm.org/route/v1/driving/${p.lng},${p.lat};${d.lng},${d.lat}?overview=false`);
    const j = await r.json();
    if (j.routes && j.routes[0]) {
      return { km: j.routes[0].distance / 1000, min: Math.max(1, Math.round(j.routes[0].duration / 60)) };
    }
  } catch { /* ignore */ }
  const km = haversineKm(p, d) * 1.3;
  return { km, min: Math.max(1, Math.round((km / 40) * 60)) };
}

// Returns { subtotal, hst, total, km, hours } or null if not computable.
// Point-to-point requires a numeric km (from routeKm); hourly uses hours.
export function estimateFare({ km, vehicle, mode = "point_to_point", hours = 0, deposit = false }) {
  let subtotal = null;
  let dist = null;
  if (mode === "hourly") {
    const rate = HOURLY_RATES[vehicle] || HOURLY_RATES["Cadillac XTS"];
    const h = Math.max(MIN_HOURS, Number(hours) || 0);
    subtotal = rate * h;
  } else {
    if (km == null || Number.isNaN(km)) return null;
    const rate = FARE_RATES[vehicle] || FARE_RATES["Cadillac XTS"];
    const raw = rate.base + km * rate.perKm;
    subtotal = Math.max(rate.base, Math.round(raw / 5) * 5);
    dist = Math.round(km);
  }
  const chargeBase = deposit ? Math.max(50, Math.round(subtotal * DEPOSIT_PCT * 100) / 100) : subtotal;
  const hst = Math.round(chargeBase * HST_RATE * 100) / 100;
  const total = Math.round((chargeBase + hst) * 100) / 100;
  return { subtotal: chargeBase, hst, total, km: dist, hours: mode === "hourly" ? Math.max(MIN_HOURS, Number(hours) || 0) : null };
}
